<template>
    <v-container fluid>
        <v-row class="mt-6 ml-3">
            <h1>問卷名稱: {{survey_title}}</h1>
        </v-row>
        <v-row v-for="(q, idx) in question_list" :key="idx" class="pa-6">
            <!-- question_id: {{q.id}} -->
            <v-col v-if="q.type==1" cols="12" sm="12">
                <choice :index="idx+1" :choice="ans_dict[q.id]" :question="q.question"></choice>
            </v-col>
            <v-col v-if="q.type==2" cols="12" sm="12">
                <essay :index="idx+1" :ans="ans_dict[q.id]" :question="q.question"></essay>
            </v-col>
                <v-col v-if="q.type==3" cols="12" sm="12">
            <matrix :index="idx+1" :question="q.question"></matrix>
            </v-col>
            <!-- 圖表 -->
            <v-col v-if="q.type==1" cols="12" sm="5">
                <ve-bar :data="analysis_dict[q.id]" :extend="chartExtend"></ve-bar>
            </v-col>
            <v-col v-if="q.type==2" cols="12" sm="12">
                <v-data-table :headers="headers" :items="analysis_dict[q.id]" hide-default-footer class="elevation-1">
                    <template v-slot:item.index="{item}">
                        {{analysis_dict[q.id].findIndex(e=>e.patient_code==item.patient_code)+1}}
                    </template>
                </v-data-table>
            </v-col>
            <v-col v-if="q.type==3" cols="12" sm="12">
                <v-row justify="space-between">
                    <v-col v-for="(a, idx2) in analysis_dict['g'+q.id]" :key="'g'+idx2" cols="5" sm="5">
                        {{a.title}}
                        <ve-bar :data="a.chart_data" :extend="chartExtend"></ve-bar>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import bus from '../nav/bus'

import Choice from '../materials/question_statistics/Choice'
import Essay from '../materials/question_statistics/Essay'
import Matrix from '../materials/question_statistics/Matrix'

var host_url = process.env.VUE_APP_HOST_URL
export default {
    components: {Choice, Essay, Matrix},
    data(){
        this.chartExtend = {
            xAxis: {
                minInterval: 1
            },

            yAxis: {
                minInterval: 1
            }
        }
        return {
            // 0: 從母問卷過來
            // 1: 從子問卷過來
            mode: -1,
            id: -1, 

            question_list: [],
            ans_dict: {},

            survey_title: '',

            analysis_dict: {},

            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '病歷號碼', align: 'center', value: 'patient_code', sortable: false},
                {text: '問答內容', align: 'center', value: 'ans', sortable: false},
            ],
        }
    },
    created(){
        // 從母問卷過來
        if('s' in this.$route.query) {
            this.mode = 0
            this.id = this.$route.query.s
        }
        else if('as' in this.$route.query){
            this.mode = 1
            this.id = this.$route.query.as
        }
        else{
            bus.$emit('alert', {msg: '操作異常', title: "提示",　check: "我知道了"})
            this.$router.push('/statistics')
        }
        this.get_question_list()
    },
    methods: {
        get_question_list(){

            let post_data; 
            if(this.mode == 1){
                post_data = {account_survey_id: this.id}
            }
            else{
                post_data = {survey_id: this.id}
            }

            axios.post(host_url+'get_question_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    console.log('get_question_list', tmp)
                    this.question_list = tmp.question_list
                    this.survey_title = tmp.survey_title
                    this.get_statistics()
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
        get_statistics(){
            let post_data; 
            if(this.mode == 1){
                post_data = {
                    account_survey_id: this.id,
                    question_list: this.question_list
                }
            }
            else{
                post_data = {
                    survey_id: this.id,
                    question_list: this.question_list
                }
            }

            // let post_data = {survey_id: this.survey_id,
            //                  question_list: this.question_list}

            axios.post(host_url+'get_statistics/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    console.log(tmp)
                    this.analysis_dict = tmp.analysis_dict
                }
                else{
                    bus.$emit('alert', {msg: tmp.msg, title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
    },
}
</script>